var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryMn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_9053)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_9053",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_9053)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3335 20H18.6668V0H9.3335V20Z",
    fill: "#146BBC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H9.33333V0H0V20Z",
    fill: "#E43642"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6665 20H27.9998V0H18.6665V20Z",
    fill: "#E43642"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66667 10L5.33333 10.6667H4.66667H4L4.66667 10ZM5.33301 14.021V14.6667H4L4.66667 16L5.33301 14.6673V16H6.66634V12H5.33333H5.33301H4.67195C5.03771 11.9971 5.33333 11.6998 5.33333 11.3333C5.33333 10.9651 5.03486 10.6667 4.66667 10.6667C4.29848 10.6667 4 10.9651 4 11.3333C4 11.6998 4.29563 11.9971 4.66138 12H4L4.66666 13.3333C4.29847 13.3333 4 13.6318 4 14C4 14.3681 4.29848 14.6666 4.66667 14.6666C5.02782 14.6666 5.3219 14.3795 5.33301 14.021ZM5.33301 13.9789V12.0006L4.66668 13.3333C5.02782 13.3333 5.3219 13.6205 5.33301 13.9789ZM2.6665 12H3.99984V16H2.6665V12Z",
    fill: "url(#paint0_linear_2858_9053)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2858_9053",
    x1: 2.6665,
    y1: 10,
    x2: 2.6665,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9CE2F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_9053"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryMn);
export default __webpack_public_path__ + "static/media/Country=MN.cedd57d5ab47f55deeab6b2f2e7d3c77.svg";
export { ForwardRef as ReactComponent };